// Real product catalogue from www.sbkmanufacturing.com
// Image URLs are sourced from the live Wix CDN (upgraded from 121x121 to 800x800)

const w = (url) => url.replace("w_121,h_121", "w_800,h_800");

export const PRODUCTS = [
  {
    slug: "classina-eco-series",
    name: "Classina A4 Eco Series",
    category: "Sustainability",
    description:
      "Eco-friendly A4 ruled notebooks with kraft covers and recyclable paper — Write Green, Live Clean.",
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/0izh8zwp_8908030416025_f.png",
    featured: true,
    brand: "Classina",
  },
  {
    slug: "classina-a5-eco-series",
    name: "Classina A5 Eco Series",
    category: "Sustainability",
    description:
      "Eco-friendly A5 ruled notebooks — 100 pages on recyclable kraft paper. Write Today, Protect Tomorrow.",
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/60el38ha_a5.png",
    featured: false,
    brand: "Classina",
  },
  {
    slug: "classina-a6-eco-series",
    name: "Classina A6 Eco Series",
    category: "Sustainability",
    description:
      "Eco-friendly A6 pocket notebooks — 100 ruled pages on recyclable kraft. Reduce, Reuse, Recycle, Repeat.",
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/bdzrk7l9_8908030416124_f.png",
    featured: false,
    brand: "Classina",
  },
  {
    slug: "classina-eco-a5-journals",
    name: "Classina Eco A5 Journals",
    category: "Sustainability",
    description:
      "A5 ruled eco journals — 160 pages on recyclable kraft, with a designer Tree of Life cover. Green Thoughts Begin Here.",
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/t2it50fj_FRONT.png",
    featured: false,
    brand: "Classina",
  },
  {
    slug: "classina-sketch-pad-artist-pro",
    name: "Classina Sketch Pad — Artist Pro",
    category: "Creative",
    description:
      "Artist Pro sketch pad — 140 GSM heavyweight paper, 50 sheets, A4 size. Built for pencils, ink and watercolours.",
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/6mchmdnv_8908030416100_f.png",
    featured: false,
    brand: "Classina",
  },
  {
    slug: "classina-studio-sketch-pad",
    name: "Classina Studio Sketch Pad",
    category: "Creative",
    description:
      "Studio sketch pad for everyday drawing — 115 GSM, 40 pages, A4 size. Smooth surface for pencil, charcoal and fine-liner work.",
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/d8x4a3v0_8908030416094_f.png",
    featured: false,
    brand: "Classina",
  },
  {
    slug: "classina-long-book",
    name: "Classina Long Book",
    category: "School & College",
    description:
      "Long-format notebooks with travel-inspired covers — Italy, desert escapes and global icons. Premium paper, long-stitched binding.",
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/ubdl8f9f_WhatsApp%20Image%202026-04-07%20at%206.48.28%20PM.jpeg",
    featured: false,
    brand: "Classina",
  },
  {
    slug: "classina-scrap-book",
    name: "Classina Scrap Book",
    category: "School & College",
    description:
      "A4 scrap books with vibrant designer covers (Blue, Maroon, Orange, Red) and a structured Page No. + Date layout — built for school assignments, art projects and creative submissions.",
    images: [
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/vq4nimwf_Front%20Cover.png",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/yf9i69be_Blue.png",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/gek4c39k_Maroon.png",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/skpt8070_oramge.png",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/354wk6d5_Red.png",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/vq4nimwf_Front%20Cover.png",
    featured: false,
    brand: "Classina",
  },
  {
    slug: "classina-graph-book",
    name: "Classina Graph Book",
    category: "School & College",
    description:
      "A4 graph books with crossed grid + ruled pages — 36 pages, perfect for math, statistics and engineering drawings.",
    images: [
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/s4dt46i0_Classina%20Graph%20Book%20-%20Front.jpg",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/zs7btw9h_Classina%20Graph%20Book%20-%20Inner%20Pages.jpg",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/h2v24r67_Classina%20Graph%20Book%20-%20Back%29.jpeg",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/s4dt46i0_Classina%20Graph%20Book%20-%20Front.jpg",
    featured: false,
    brand: "Classina",
  },
  {
    slug: "classina-lever-arch-signature",
    name: "Classina Signature Lever Arch File",
    category: "Office & Filing",
    description:
      "Heavy-duty foolscap lever arch box file in marble finish — durable two-ring mechanism, reinforced metal eyelet and dual-label spine. Available in Black, Green, Royal Blue and Red.",
    image: "/uploads/classina-lever-arch-black.jpg",
    images: [
      "/uploads/classina-lever-arch-black.jpg",
      "/uploads/classina-lever-arch-green.jpg",
      "/uploads/classina-lever-arch-royal-blue.jpg",
      "/uploads/classina-lever-arch-red.jpg",
      "/uploads/classina-lever-arch-detail.jpg",
    ],
    featured: false,
    brand: "Classina",
  },
  {
    slug: "journals",
    name: "Journals",
    category: "Corporate & Gifting",
    description:
      "Softcover neon journals with high quality paper, ideal for daily writing, gifting and creative routines.",
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/uy6odnlu_IMG-20240224-WA0027.jpg",
    featured: true,
  },
  {
    slug: "classina-a5-journals",
    name: "Fashion Journal",
    category: "Corporate & Gifting",
    description:
      "Softbound A5 fashion journals with perfect binding and ruled 144 pages — featuring designer covers across travel, florals, abstract art and inspirational themes. Smooth ivory paper, ideal for daily writing and gifting.",
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/zjfwh7d4_Bloom%20like%20magic%20notebook%20design%20Classina.png",
    images: [
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/zjfwh7d4_Bloom%20like%20magic%20notebook%20design%20Classina.png",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/4asnznw9_2.jpeg",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/1eiwcdnm_3.jpeg",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/fxovysfp_WhatsApp%20Image%202026-04-26%20at%202.11.47%20PM.jpeg",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/dyjn8y21_WhatsApp%20Image%202026-04-21%20at%204.30.00%20PM%20%282%29.jpeg",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/fh9w49sx_WhatsApp%20Image%202026-04-21%20at%204.30.00%20PM%20%283%29.jpeg",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/gbx4h628_WhatsApp%20Image%202026-04-21%20at%204.30.00%20PM%20%284%29.jpeg",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/ula803v9_WhatsApp%20Image%202026-04-21%20at%204.30.00%20PM%20%285%29.jpeg",
      "/uploads/squeeze-the-day-clean.jpeg",
    ],
    featured: false,
    brand: "Classina",
  },
  {
    slug: "composition-notebooks",
    name: "Composition Notebooks",
    category: "School & College",
    description:
      "Classic stitched composition books — durable covers, ruled pages, made for daily classroom use.",
    image: w(
      "https://static.wixstatic.com/media/ec70f4_2eef668adb9844d4bbf03a06753a8507~mv2.png/v1/crop/x_1,y_0,w_998,h_998/fill/w_121,h_121,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/image.png"
    ),
    featured: true,
  },
  {
    slug: "spiral-subject-books",
    name: "Spiral Subject Books",
    category: "School & College",
    description:
      "Wire-bound multi-subject notebooks with tabbed dividers — lay-flat writing across every page.",
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/pg8x1f6z_603f8109-9105-4598-8b1f-c26a255dab9c.png",
    images: [
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/pg8x1f6z_603f8109-9105-4598-8b1f-c26a255dab9c.png",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/q7o0kmdw_5%20sub.png",
    ],
    featured: true,
  },
  {
    slug: "a5-school-notebooks",
    name: "A5 School Notebooks",
    category: "School & College",
    description:
      "Compact A5 ruled notebooks built for students — long-stitched binding, sturdy covers.",
    image: "/uploads/classina-a5-front.jpg",
    featured: false,
    brand: "Classina",
  },
  {
    slug: "a4-college-books",
    name: "A4 College Books",
    category: "School & College",
    description:
      "Classina A4 softbound notebooks with vibrant covers — smooth writing paper for higher education.",
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/a6b3zxmb_Classina%20A4%202026.png",
    featured: false,
    brand: "Classina",
  },
  {
    slug: "drawing-books",
    name: "Classina A4 Drawing Book",
    category: "Creative",
    description:
      "Super Yellow A4 drawing books with thick cartridge paper — ideal for sketching, painting and craft.",
    image:
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/to8dcdyp_YDB%20PNT.png",
    featured: false,
    brand: "Classina",
  },
  {
    slug: "diaries",
    name: "Diaries",
    category: "Corporate & Gifting",
    description:
      "Dated and undated diaries with elegant covers — a long-loved corporate gifting staple.",
    image: w(
      "https://static.wixstatic.com/media/ec70f4_2f4a74fc77694046bf06b6e77e2f7c8c~mv2.jpg/v1/crop/x_58,y_0,w_454,h_454/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/note-books-1490593258-2783923.jpg"
    ),
    featured: true,
  },
  {
    slug: "sketch-books",
    name: "Sketch Books",
    category: "Creative",
    description:
      "Top-glued sketch pads with high-GSM paper — built for pencils, pens and watercolours.",
    image: w(
      "https://static.wixstatic.com/media/ec70f4_347280e74f8441cab398ecbe9eb405f0~mv2.jpg/v1/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Top%20Glu_edited.jpg"
    ),
    featured: false,
  },
  {
    slug: "filler-paper",
    name: "Filler Paper",
    category: "Loose Sheets",
    description:
      "Pre-punched ruled filler paper for binders and folders — consistent quality, bulk packed.",
    image: w(
      "https://static.wixstatic.com/media/ec70f4_aac0bd1f325d4fd18c3a6335e6ec47c4~mv2.png/v1/fill/w_121,h_121,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/image.png"
    ),
    images: [
      w(
        "https://static.wixstatic.com/media/ec70f4_aac0bd1f325d4fd18c3a6335e6ec47c4~mv2.png/v1/fill/w_121,h_121,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/image.png"
      ),
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/wskw6ztd_d9918893-7c5f-422e-a2e5-32c3f5e8c888.png",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/1jkfsonm_ae071a47-aa07-4c48-86f0-b99f5eb5fcbd.png",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/k4p0md0x_522553.jpg",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/mxpe7n3u_notebook-filler-paper-9156988.webp",
    ],
    featured: true,
  },
  {
    slug: "counter-books",
    name: "Counter Books",
    category: "Office & Trade",
    description:
      "Heavy-duty register books with reinforced spines — built for shops, ledgers and accounts.",
    image: w(
      "https://static.wixstatic.com/media/ec70f4_bff053ae4278439eb39ce4f824b0bfbe~mv2.jpg/v1/crop/x_156,y_0,w_2349,h_2349/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG-20231127-WA0024_edited.jpg"
    ),
    images: [
      w(
        "https://static.wixstatic.com/media/ec70f4_bff053ae4278439eb39ce4f824b0bfbe~mv2.jpg/v1/crop/x_156,y_0,w_2349,h_2349/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG-20231127-WA0024_edited.jpg"
      ),
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/4hn4xm3g_IMG-20231127-WA0024.jpg",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/fr1s5tfk_IMG-20231127-WA0023.jpg",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/t44xbgxr_3Q%20INTER.avif",
      "https://customer-assets.emergentagent.com/job_revamp-2024/artifacts/ov22yv4w_IMG-20231127-WA0016.jpg",
    ],
    featured: false,
  },
  {
    slug: "fat-books",
    name: "Fat Books",
    category: "Office & Trade",
    description:
      "Thick-spine notebooks for long-form writing, registers and high-volume note keeping.",
    image: w(
      "https://static.wixstatic.com/media/ec70f4_710df62595d6430089b08f44a6700b12~mv2.jpg/v1/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Fat%20Book.jpg"
    ),
    featured: false,
  },
  {
    slug: "rough-books",
    name: "Rough Books",
    category: "School & College",
    description:
      "Affordable rough books with kraft covers — perfect for drafts, calculations and notes.",
    image: w(
      "https://static.wixstatic.com/media/ec70f4_0f14e34e95b442959d31c0ca6dc20a74~mv2.jpg/v1/crop/x_591,y_0,w_2481,h_2481/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Rough%20Book.jpg"
    ),
    featured: false,
    brand: "Classina",
  },
  {
    slug: "construction-papers",
    name: "Construction Papers",
    category: "Specialty",
    description:
      "Coloured construction paper pads in standard sizes — vibrant, art-grade, classroom-ready.",
    image: w(
      "https://static.wixstatic.com/media/ec70f4_f4ed9aae2e5843ee88b2b0a77a4a107a~mv2.jpg/v1/crop/x_576,y_0,w_3456,h_3456/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/6X9%20CONST%20PAD%202_JPG.jpg"
    ),
    featured: false,
  },
  {
    slug: "notepads",
    name: "Notepads",
    category: "Office & Trade",
    description:
      "Top-glued notepads in multiple sizes — for desks, offices and corporate stationery sets.",
    image: w(
      "https://static.wixstatic.com/media/ec70f4_3f81f8d1518b42cbb8f255781f89fcae~mv2.jpg/v1/crop/x_0,y_46,w_317,h_317/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/notepad_edited.jpg"
    ),
    featured: false,
  },
  {
    slug: "index-cards",
    name: "Index Cards",
    category: "Loose Sheets",
    description:
      "Ruled and blank index cards in multiple sizes — for study, filing and presentations.",
    image: w(
      "https://static.wixstatic.com/media/ec70f4_f6349f54ce814f469ff063ea45862b0a~mv2.png/v1/crop/x_0,y_1,w_998,h_998/fill/w_121,h_121,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/image.png"
    ),
    featured: false,
  },
];

export const FEATURED_PRODUCTS = PRODUCTS.filter((p) => p.featured);
export const SBK_CATALOGUE = PRODUCTS.filter((p) => p.brand !== "Classina");
export const CLASSINA_PRODUCTS = PRODUCTS.filter((p) => p.brand === "Classina");
